export const cashInstanceTypes = [
    'sale',
    'remuneration',
    'commission'
]

export const paymentTypes = [
    'downPayment',
    'balancePayment',
    'penaltyPayment',
    'refundPayment'
]

export const paymentSubtypes = [
    'principal',
    'miscelaneous',
    'rental',
    'reservation',
    'spot',
    'single',
    'multiple',
    'loan difference',
    'penalty',
    'counter offer'
]

export const paymentStatuses = [
    'open',
    'pastDue',
    'completed',
    'canceled'
]

export const letterTypes = [
    'downPayment',
    'balancePayment',
    'penaltyPayment'
]

export const letterSubtypes = [
    'firstLetter',
    'secondLetter',
    'thirdLetter'
]

export const letterStatuses = [
    'open',
    'late',
    'sent',
    'canceled',
    'paid'
]

export const unitStatuses = [
    'unavailable',
    'available',
    'sold',
    'reserved'
]

export const unitOrietantion = [
    'left',
    'right'
]

export const clientActionsStatuses = [
    'open',
    'completed'
]

export const permissions = {
    'SuperAdmin': [
        'CreateUser',
        'EditUser',
        'ViewUser',
        'CreateClient',
        'EditClient',
        'EditSeller',
        'ViewClient',
        'ViewSeller',
        'CreateSeller',
        'ViewBroker',
        'EditBroker',
        'CreateBroker',
        'CreatePayment',
        'EditPayment',
        'ViewPayment',
        'ViewCommission',
        'CreateCommission',
        'EditCommission',
        'CreateLetter',
        'EditLetter',
        'ViewLetter',
        'ViewProject',
        "EditProject",
        "CreateProject",
        'ViewUnit',
        'CreateUnit',
        'EditUnit',
        'ViewClientAction',
        'CreateClientAction',
        'EditClientAction',
    ],
    'Sales': [
        'ViewUser',
        'CreateClient',
        'EditClient',
        'EditSeller',
        'CreateSeller',
        'ViewBroker',
        'EditBroker',
        'CreateBroker',
        'ViewClient',
        'ViewSeller',
        'ViewPayment',
        'ViewLetter',
        'ViewCommission',
        'ViewProject',
        'ViewUnit',
        'ViewClientAction'
    ],
    'SalesAdmin': [
        'ViewUser',
        'ViewClient',
        'CreateClient',
        'EditClient',
        'ViewBroker',
        'EditBroker',
        'CreateBroker',
        'ViewSeller',
        'EditSeller',
        'CreateSeller',
        'CreatePayment',
        'EditPayment',
        'ViewPayment',
        'ViewLetter',
        'ViewCommission',
        'CreateCommission',
        'EditCommission',
        'ViewProject',
        'ViewUnit',
    ],
    'AR': [
        'ViewUser',
        'ViewClient',
        'ViewSeller',
        'ViewPayment',
        'ViewBroker',
        'CreateLetter',
        'EditLetter',
        'ViewLetter',
        'ViewCommission',
        'ViewProject',
        'ViewUnit',
    ],
    'Actg': [
        'ViewUser',
        'ViewClient',
        'ViewSeller',
        'CreatePayment',
        'EditPayment',
        'ViewBroker',
        'ViewPayment',
        'CreateLetter',
        'EditLetter',
        'ViewLetter',
        'ViewCommission',
        'CreateCommission',
        'EditCommission',
        'ViewProject',
        'ViewUnit',
    ]
}